import React from "react";
import styled from "@emotion/styled";

import { BATTLERUSH_ARENA_TITLE } from "../../../constants";
import { SMALL_DEVICES } from "../../../mediaQueries";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  font-size: 32px;
  color: white;
  margin-bottom: 10px;

  ${SMALL_DEVICES} {
    text-align: center;
  }
`;

const Description = styled.div`
  font-size: 24px;
  color: white;
  font-weight: lighter;
  margin-bottom: 10px;
`;

export const Devlogs: React.FC = (props) => {
  return (
    <Container>
      <Title>Check out the development of our games!</Title>
      <Description>{BATTLERUSH_ARENA_TITLE}</Description>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/videoseries?list=PLB_Jkrnfj-A9n6fCI0zAefc2ZK30vkOGp"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </Container>
  );
};
